import React, { useRef, useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";
import VisitorTracker from "./VisitorTracker";

const Career = () => {
  const form = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [visitorLocation, setVisitorLocation] = useState(null);

  const SERVICE_ID = "service_x0qp7zc";
  const TEMPLATE_ID = "template_qv0m4u4";
  const PUBLIC_KEY = "tmTWW-hXcDhbB5j6e";

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch("https://ipinfo.io/json");
        const data = await response.json();

        console.log(data);

        setVisitorLocation({
          city: data.city || "",
          country: data.country || "",
          ip: data.ip || "",
          region: data.region || "",
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetchLocation();
  }, []);

  useEffect(() => {
    console.log("Visitor Location:", visitorLocation);
  }, [visitorLocation]);

  const sendEmail = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const formData = new FormData(form.current);
      const name = formData.get("name");
      const email = formData.get("email");
      const mobile = formData.get("mobile");
      const position = formData.get("position");
      const yourself = formData.get("yourself");
      const resume = formData.get("brief");

      console.log("Name:", name);
      console.log("Email:", email);
      console.log("Mobile:", mobile);
      console.log("Position:", position);
      console.log("Yourself:", yourself);
      console.log("Resume:", resume);
      
      const emailFormData = new FormData();
      emailFormData.append("name", name);
      emailFormData.append("email", email);
      emailFormData.append("mobile", mobile);
      emailFormData.append("position", position);
      emailFormData.append("yourself", yourself);
      if (resume) {
        emailFormData.append("resume", resume);
      }

      if (visitorLocation) {
        emailFormData.append("visitor_city", visitorLocation.city);
        emailFormData.append("visitor_country", visitorLocation.country);
        emailFormData.append("visitor_ip", visitorLocation.ip);
        emailFormData.append("visitor_region", visitorLocation.region);
        emailFormData.append("visitor_postal", visitorLocation.postal);
        emailFormData.append("submission_time", new Date().toLocaleString());
      } else {
        try {
          const response = await fetch("https://ipapi.co/json/");
          const data = await response.json();
          console.log("Fallback API Response:", data);
          
          emailFormData.append("visitor_city", data.city || "");
          emailFormData.append("visitor_country", data.country_name || "");
          emailFormData.append("visitor_ip", data.ip || "");
          emailFormData.append("visitor_region", data.region || "");
          emailFormData.append("visitor_postal", data.postal || "");
          emailFormData.append("submission_time", new Date().toLocaleString());
        } catch (err) {
          console.error("Fallback API also failed:", err);
          emailFormData.append("visitor_city", "");
          emailFormData.append("visitor_country", "");
          emailFormData.append("visitor_ip", "");
          emailFormData.append("visitor_region", "");
          emailFormData.append("visitor_postal", "");
          emailFormData.append("submission_time", new Date().toLocaleString());
        }
      }

      const result = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        Object.fromEntries(emailFormData),
        PUBLIC_KEY,
      );

      console.log("Visitor City:", visitorLocation?.city);
      console.log("Visitor Country:", visitorLocation?.country);
      console.log("Visitor IP:", visitorLocation?.ip);
      console.log("Visitor Region:", visitorLocation?.region);
      console.log("Visitor Postal:", visitorLocation?.postal);
      console.log("Email sent successfully:", result.text);
      alert("✅ Application Submitted Successfully! We'll contact you soon.");
      e.target.reset();
    } catch (error) {
      console.error("Email send error:", error);
      alert("❌ Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <VisitorTracker />
      <div
        className="container-fluid p-0 banner-section"
        style={{ backgroundImage: "url('/img/career.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-2 text-white text-center">
            <h1 className="pt-5 mt-5">Career</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Career
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="container justify-content-center mt-3 mb-3">
        <div className="row">
          <div className="col-md-5 p-2 m-3 pt-20">
            <img
              src="img/job.webp"
              className="img-fluid w-100 h-30"
              alt="Career"
            />
          </div>

          <div className="col-md-6">
            <form
              ref={form}
              onSubmit={sendEmail}
              encType="multipart/form-data"
              method="post"
              className="container shadow"
              style={{ borderRadius: "10px" }}
            >
              <p className="fw-bold text-primary text-center pt-2 fs-4">
                Job Application Form
              </p>
              <div className="row">
                <div className="form-group col-md-6 my-2">
                  <label htmlFor="name">Your Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    id="name"
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div className="form-group col-md-6 my-2">
                  <label htmlFor="email">Your Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter your Email"
                    required
                  />
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-6 my-2">
                  <label htmlFor="mobile">Mobile Number</label>
                  <input
                    type="tel"
                    name="mobile"
                    className="form-control"
                    id="mobile"
                    placeholder="Enter your Number"
                    required
                  />
                </div>
                <div className="form-group col-md-6 my-2">
                  <label htmlFor="position">
                    Position That suits your Experience
                  </label>
                  <input
                    type="text"
                    name="position"
                    className="form-control"
                    id="position"
                    placeholder="Enter your position that suits your experience"
                    required
                  />
                </div>
              </div>
              <div className="col-md-12 my-2">
                <label htmlFor="fileUpload" className="form-label">
                  Upload Your Resume File
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="brief"
                  id="fileUpload"
                />
              </div>

              <div className="form-group col-md-12 my-3">
                <label htmlFor="yourself">More Info About Yourself</label>
                <textarea
                  className="form-control"
                  name="yourself"
                  id="yourself"
                  rows="2"
                  required
                ></textarea>
              </div>
              <div className="form-group text-end col-md-12 pb-2">
                <button className="btn btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Apply"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Career;